import React from "react";
import { Card } from "react-bootstrap";

import ExportCSVForm from "../../../components/exportCSVForm";

const ExportCSVFile: React.FC = () => {
	return (
		<>
			<Card className="">
				<Card.Header>
					<h5>Export CSV File</h5>
				</Card.Header>
				<Card.Body className="bg-light">
					<ExportCSVForm />
				</Card.Body>
			</Card>
		</>
	);
};

export default ExportCSVFile;
